export default {
  authUser(state, data) {
    state.token = data.accessToken;
    state.menu = data.JsonMenu;
    state.userId = data.userId;
    state.userRole = data.role;
  },

  updateUserId(state, data) {
    state.userId = data;
  },

  setRequestsCount(state, data) {
    state.requestsCount = data;
  },

  setLoginCheck(state, data) {
    state.loginCheck = data;
  },

  setCheckCode(state, data) {
    state.checkCode = data;
  },

  clearAuth(state) {
    state.token = null;
  },

  // Alert Handles ---------------------------------------

  setPostCheck(state, data) {
    state.postCheck = data;
  },

  setInfo(state, data) {
    state.checkAlert = 4;
    state.infoMessage = data;
  },

  setWarning(state, data) {
    state.checkAlert = 3;
    state.warningMessage = data;
  },

  setError(state, data) {
    state.checkAlert = 2;
    state.dangerMessage = data;
  },

  setSuccess(state, data) {
    state.checkAlert = 1;
    state.successMessage = data;
  },

  expireAlert(state) {
    state.checkAlert = 0;
    state.successMessage = null;
    state.dangerMessage = null;
    state.warningMessage = null;
    state.infoMessage = null;
  },

  setLoading(state, data) {
    state.loadingCheck = data.status;
    state.loadingMessage = data.message;
  },

  setLoadingBtn(state, data) {
    state.loadingBtn = data
  },

  setDeviceRegistrationToken(state, data) {
    state.deviceRegistrationToken = data;
  },


};
